export default __webpack_public_path__ + "locales/fi/Payments.json?hash=69428ed5d006147926a32ec366b3b300";